import React from "react";
import {
    CrossIcon,
    StyledSelectInput,
    StyledLabel,
    StyledTextInput,
} from "@aureskonnect/react-ui";
import { AvForm, AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";
import { Spinner } from "reactstrap";

import { resetAllPeripherals } from "@pages/Applications/DeviceAssociateModal/store";
import {
    setActions,
    setIsActionsClicked,
} from "@pages/Peripherals/Monetics/store";

import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import {
    CustomCardHeader,
    CustomCardBody,
    CustomCardFooter,
} from "@components/Common/CustomCardStyled";
import { ipMatchWord, MONETIC_MARK_OPTIONS } from "../../../../constants";
import { AdyenConfiguration } from "./AdyenConfig";
import { ValinaConfig } from "./ValinaConfig";
import { NeptingConfig } from "./NeptingConfig";
import { ValinaSwissConfig } from "./ValinaSwisseConfig";

import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

import "./index.css";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import { YavinConfig } from "./YavinConfig";

import { useMoneticsApplicationForm } from "./useMoneticsApplicationForm";

type MoneticsFormType = {
    setIsAddMoneticsClicked: any;
    isAddMoneticsClicked: boolean;
    setDataIsUpdated: React.Dispatch<React.SetStateAction<boolean | number>>;
    editedData: React.SetStateAction<any>;
    setIsAddNewMoneticsButtonClicked: React.Dispatch<
        React.SetStateAction<boolean>
    >;
    isAddNewMoneticsButtonClicked: boolean;
    setEditedData: Function;
    idShop: string;
    isEdited: boolean;
    setIsEdited: Function;
    selectMark: boolean;
    setSelectMark: Function;
    inputDesignation: boolean;
    setInputDesignation: Function;
    setInputIp: Function;
    InputIp: boolean;
    shopIds?: any;
    tableData?: any;
    setIsUpdateOperation: Function;
    setIpExist: Function;
    ipExist: boolean;
    isConsult: boolean;
    setIsConsult: Function;
    selectedRows: any;
    isModalAssociate?: boolean;
};

export default function MoneticsApplicationForm({
    setIsAddMoneticsClicked,
    isAddMoneticsClicked,
    setDataIsUpdated,
    editedData,
    isAddNewMoneticsButtonClicked,
    idShop,
    setEditedData,
    isEdited,
    setIsEdited,
    selectMark,
    setSelectMark,
    inputDesignation,
    setInputDesignation,
    setInputIp,
    InputIp,
    shopIds,
    tableData,
    setIsUpdateOperation,
    setIpExist,
    ipExist,
    isConsult,
    setIsConsult,
    selectedRows,
    isModalAssociate,
}: MoneticsFormType) {
    const {
        t,
        isActionsClicked,
        title,
        designation,
        setDesignation,
        mark,
        remarque,
        setRemarque,
        reference,
        setReference,
        isNameExist,
        isModalOpened,
        setIsModalOpened,
        portSelectInput,
        setPortSelectInput,
        speedSelectInput,
        setSpeedSelectInput,
        selectInputPM,
        setSelectInputPM,
        SelectInput,
        setSelectInput,
        InputPort,
        setInputPort,
        InputCode,
        setInputCode,
        InputUrl,
        setInputUrl,
        inputSetupType,
        setInputSetupType,
        inputTerminalType,
        setInputTerminalType,
        inputWebhook,
        setInputWebhook,
        inputMode,
        setInputMode,
        inputTimeout,
        setInputTimeout,
        inputCurrency,
        setInputCurrency,
        inputID,
        setInputID,
        inputIdIntegrator,
        setInputIdIntegrator,
        inputPortAdyen,
        setInputPortAdyen,
        inputKey,
        setInputKey,
        inputSerialNumber,
        setInputSerialNumber,
        port,
        setPort,
        speed,
        setSpeed,
        kiss,
        setKiss,
        ipAddress,
        setIpAddress,
        webhook,
        setWebhook,
        mode,
        setMode,
        merchantCode,
        setMerchantCode,
        paymentType,
        setPaymentType,
        url,
        setUrl,
        typeConfig,
        setTypeConfig,
        typeTerminal,
        setTypeTerminal,
        timeout,
        setTimeOut,
        paymentMethod,
        setPaymentMethod,
        idIntegrator,
        setIdIntegrator,
        autoValidate,
        setAutoValidate,
        currency,
        setCurrency,
        isIdExist,
        setIsIdExist,
        isDisabled,
        setIsDisabled,
        IDAdyen,
        selectedIdAdyen,
        setSelectedIdAdyen,
        isShopHasAdyen,
        merchantAccountId,
        adyenConfig,
        setAdyenConfig,
        isAutoFill,
        setIsAutoFill,
        setAdyenIpExist,
        keyValue,
        setKey,
        serialNumber,
        setSerialNumber,
        communication,
        setCommunication,
        paramsTypes,
        list_payment_method,
        speeds,
        ports,
        typeOfConfig,
        typeOfTerminal,
        pathname,
        numberMatchWord,
        handleOnChangeMark,
        handleValidate,
    } = useMoneticsApplicationForm({
        setIsAddMoneticsClicked,
        isAddMoneticsClicked,
        setDataIsUpdated,
        editedData,
        isAddNewMoneticsButtonClicked,
        setEditedData,
        idShop,
        isEdited,
        setIsEdited,
        selectMark,
        setSelectMark,
        inputDesignation,
        setInputDesignation,
        setInputIp,
        InputIp,
        shopIds,
        tableData,
        setIsUpdateOperation,
        setIpExist,
        ipExist,
        isConsult,
        setIsConsult,
        selectedRows,
        isModalAssociate,
    });

    return (
        <React.Fragment>
            <AvForm className="card">
                <CustomCardHeader
                    className="d-flex align-items-center justify-content-between"
                    style={{ maxHeight: "76px" }}
                >
                    <h5 className="pt-3 mnt_txt_addPaymentDevice">{title}</h5>
                    <CrossIcon
                        className="icon-close-notification__clz mnt_icn_closeForm"
                        height={13}
                        width={13}
                        onClick={() => {
                            const closeForm = () => {
                                resetAllPeripherals();
                                setEditedData([]);
                                setIsAddMoneticsClicked!(!isAddMoneticsClicked);
                                setDataIsUpdated!(true);
                                setIsEdited(false);
                                setIsConsult(false);
                            };
                            if (isEdited) {
                                setIsActionsClicked(!isActionsClicked);
                                setActions(closeForm);
                            } else {
                                closeForm();
                            }
                        }}
                    />
                </CustomCardHeader>
                <CustomCardBody
                    className="pl-3 pr-5"
                    style={{
                        maxHeight:
                            pathname === "/peripherals/monetics"
                                ? "500px"
                                : "522px",
                        overflowY: " scroll",
                    }}
                >
                    <AvGroup>
                        <StyledLabel
                            htmlFor="text"
                            className="required__clz mt-3 "
                        >
                            {t("Designation")}
                        </StyledLabel>
                        <StyledTextInput
                            className={classnames("mnt_inp_name ", {
                                input__clz:
                                    inputDesignation ||
                                    (isNameExist &&
                                        (shopIds === undefined ||
                                            shopIds.length === 0)) ||
                                    (isNameExist && shopIds.length >= 1) ||
                                    (designation?.trim() === "" &&
                                        designation !== "") ||
                                    (designation !== "" &&
                                        !/^[a-zA-Z0-9]*$/.test(designation) &&
                                        mark === "Yavin"),
                                readOnly__clz: isConsult,
                            })}
                            autocomplete="off"
                            name="designation"
                            onChange={(e: any) => {
                                setDesignation(e.target.value);
                                setIsEdited(true);
                                setInputDesignation(false);
                            }}
                            value={designation}
                            placeholder={t("Write")}
                            type="text"
                            autoFocus={!isConsult}
                        />
                        {(isNameExist &&
                            (shopIds === undefined || shopIds.length === 0)) ||
                        (isNameExist && shopIds.length >= 1) ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("The name is already exists")!}
                            </div>
                        ) : null}
                        {inputDesignation ||
                        (designation?.trim() === "" && designation !== "") ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("Please enter a designation")}
                            </div>
                        ) : null}
                        {designation !== "" &&
                        !/^[a-zA-Z0-9]*$/.test(designation) &&
                        mark === "Yavin" ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t(
                                    "Designation must contain only alphanumeric characters"
                                )}
                            </div>
                        ) : null}
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel
                            htmlFor="text"
                            className="required__clz mt-3"
                        >
                            {t("Monetic type")}
                        </StyledLabel>
                        <React.Fragment>
                            <StyledSelectInput
                                className={classnames("mnt_inp_mark", {
                                    invalid__clz: selectMark,
                                    "not-allowed-input__clz":
                                        editedData.Id !== undefined,
                                    readOnly__clz: isConsult,
                                })}
                                placeholder={t("Select")}
                                onChange={async (e: any) => {
                                    handleOnChangeMark(e);
                                }}
                                options={MONETIC_MARK_OPTIONS}
                                value={
                                    mark === ""
                                        ? null
                                        : { label: mark, value: mark }
                                }
                                name="mark"
                                noOptionsMessage={() => t("No options")}
                            />
                        </React.Fragment>

                        {selectMark ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("Please select a mark")}
                            </div>
                        ) : null}
                    </AvGroup>
                    {mark === "Valina" ? (
                        <ValinaConfig
                            port={port}
                            portSelectInput={portSelectInput}
                            isConsult={isConsult}
                            ports={ports}
                            setPortSelectInput={setPortSelectInput}
                            setPort={setPort}
                            setReference={setReference}
                            reference={reference}
                            setIsEdited={setIsEdited}
                            speedSelectInput={speedSelectInput}
                            speed={speed}
                            speeds={speeds}
                            setSpeedSelectInput={setSpeedSelectInput}
                            setSpeed={setSpeed}
                            selectInputPM={selectInputPM}
                            list_payment_method={list_payment_method}
                            paymentMethod={paymentMethod}
                            setPaymentMethod={setPaymentMethod}
                            setSelectInputPM={setSelectInputPM}
                            inputTimeout={inputTimeout}
                            setTimeOut={setTimeOut}
                            setInputTimeout={setInputTimeout}
                            timeout={timeout}
                            kiss={kiss}
                            setKiss={setKiss}
                        />
                    ) : mark === "Nepting" ? (
                        <NeptingConfig
                            port={port}
                            isConsult={isConsult}
                            setPort={setPort}
                            setIsEdited={setIsEdited}
                            InputIp={InputIp}
                            ipExist={ipExist}
                            setIpAddress={setIpAddress}
                            ipMatchWord={ipMatchWord}
                            setInputIp={setInputIp}
                            ipAddress={ipAddress}
                            setReference={setReference}
                            reference={reference}
                            InputPort={InputPort}
                            setInputPort={setInputPort}
                            numberMatchWord={numberMatchWord}
                            InputCode={InputCode}
                            setMerchantCode={setMerchantCode}
                            setInputCode={setInputCode}
                            merchantCode={merchantCode}
                            paymentType={paymentType}
                            SelectInput={SelectInput}
                            paramsTypes={paramsTypes}
                            setSelectInput={setSelectInput}
                            setPaymentType={setPaymentType}
                            InputUrl={InputUrl}
                            setUrl={setUrl}
                            setInputUrl={setInputUrl}
                            url={url}
                            inputSetupType={inputSetupType}
                            typeConfig={typeConfig}
                            setTypeConfig={setTypeConfig}
                            typeOfConfig={typeOfConfig}
                            setInputSetupType={setInputSetupType}
                            inputTerminalType={inputTerminalType}
                            typeTerminal={typeTerminal}
                            typeOfTerminal={typeOfTerminal}
                            setTypeTerminal={setTypeTerminal}
                            setInputTerminalType={setInputTerminalType}
                        />
                    ) : mark === "Adyen" ? (
                        <AdyenConfiguration
                            isIdExist={isIdExist}
                            setIsIdExist={setIsIdExist}
                            port={port}
                            setPort={setPort}
                            webhook={webhook}
                            setWebhook={setWebhook}
                            inputWebHook={inputWebhook}
                            ipAddress={ipAddress}
                            setIpAddress={setIpAddress}
                            inputIp={InputIp}
                            ipExist={ipExist}
                            mode={mode}
                            setMode={setMode}
                            inputMode={inputMode}
                            setInputWebhook={setInputWebhook}
                            setInputIp={setInputIp}
                            setInputMode={setInputMode}
                            setAdyenIpExist={setAdyenIpExist}
                            setIsEdited={setIsEdited}
                            isConsult={isConsult}
                            setInputPortAdyen={setInputPortAdyen}
                            inputPortAdyen={inputPortAdyen}
                            shopIds={shopIds}
                            editedData={editedData}
                            IDAdyen={IDAdyen}
                            setSelectedIdAdyen={setSelectedIdAdyen}
                            selectedIdAdyen={selectedIdAdyen}
                            isShopHasAdyen={isShopHasAdyen}
                            merchantAccountId={merchantAccountId}
                            currencyByShop={currency}
                            setAdyenConfig={setAdyenConfig}
                            adyenConfig={adyenConfig}
                            isAutoFill={isAutoFill}
                            setIsAutoFill={setIsAutoFill}
                            isDisabled={isDisabled}
                            setIsDisabled={setIsDisabled}
                            setInputID={setInputID}
                            inputID={inputID}
                        />
                    ) : mark === "Valina swiss" ? (
                        <ValinaSwissConfig
                            setIdIntegrator={setIdIntegrator}
                            setInputIdIntegrator={setInputIdIntegrator}
                            setIsEdited={setIsEdited}
                            idIntegrator={idIntegrator}
                            inputIdIntegrator={inputIdIntegrator}
                            isConsult={isConsult}
                            setAutoValidate={setAutoValidate}
                            autoValidate={autoValidate}
                            inputCurrency={inputCurrency}
                            setCurrency={setCurrency}
                            setInputCurrency={setInputCurrency}
                            currency={currency}
                            terminalType={typeTerminal}
                            inputTerminalType={inputTerminalType}
                            setTerminalType={setTypeTerminal}
                            setInputTerminalType={setInputTerminalType}
                        />
                    ) : mark === "Yavin" ? (
                        <YavinConfig
                            setIsEdited={setIsEdited}
                            isConsult={isConsult}
                            setMode={setMode}
                            mode={mode}
                            inputIp={InputIp}
                            setInputIp={setInputIp}
                            ipExist={ipExist}
                            ipAddress={ipAddress}
                            setIpAddress={setIpAddress}
                            keyValue={keyValue}
                            setKey={setKey}
                            inputKey={inputKey}
                            setInputKey={setInputKey}
                            serialNumber={serialNumber}
                            setSerialNumber={setSerialNumber}
                            inputSerialNumber={inputSerialNumber}
                            setInputSerialNumber={setInputSerialNumber}
                            communication={communication}
                            setCommunication={setCommunication}
                            isConfig={false}
                            port={port}
                            setPort={setPort}
                            portSelectInput={portSelectInput}
                            setPortSelectInput={setPortSelectInput}
                        />
                    ) : null}

                    <AvGroup>
                        <StyledLabel className="mt-3" htmlFor="text">
                            {t("Remark")}
                        </StyledLabel>
                        <StyledTextInput
                            className={classnames("mnt_inp_remark", {
                                readOnly__clz: isConsult,
                            })}
                            autocomplete="off"
                            name="remarque"
                            onChange={(e: any) => {
                                setRemarque(e.target.value);
                                setIsEdited(true);
                            }}
                            value={remarque}
                            placeholder={t("Write")}
                            type="text"
                        />
                    </AvGroup>
                </CustomCardBody>
                <CustomCardFooter className="pt-1 pb-2 ">
                    <CustomSecondaryColorButton
                        outline
                        rounded
                        className="mr-2 mnt_btn_cancel cmn_btn_cancel"
                        variant="light"
                        onClick={() => {
                            const cancelForm = () => {
                                setIsAutoFill(false);
                                setIsAddMoneticsClicked(!isAddMoneticsClicked);
                                setDataIsUpdated!(true);
                                setEditedData([]);
                                setInputIp(false);
                                setIsConsult(false);
                                setIsEdited(false);
                            };
                            if (isEdited) {
                                setIsActionsClicked(!isActionsClicked);
                                setActions(cancelForm);
                            } else {
                                cancelForm();
                            }
                        }}
                    >
                        <span> {t("Cancel")}</span>
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        rounded
                        className={classnames(
                            "mr-2 mnt_btn_validate cmn_btn_validate",
                            {
                                "not-allowed-icon__clz": isConsult,
                            }
                        )}
                        variant="primary"
                        onClick={handleValidate}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </CustomCardFooter>
            </AvForm>
            <ConfirmationEditMessage
                isModalOpened={isModalOpened}
                setIsModalOpened={setIsModalOpened}
                setIsAddClicked={setIsAddMoneticsClicked}
                setEditedData={setEditedData}
            />
            {isDisabled ? (
                <Spinner
                    style={{
                        position: "absolute",
                        top: "55%",
                        left: "83%",
                        color: "gray",
                    }}
                />
            ) : null}
        </React.Fragment>
    );
}
